// extracted by mini-css-extract-plugin
export var active = "_2k-a";
export var activeIndicator = "_2k-8";
export var animate = "_2k-9";
export var disabled = "_2k-b";
export var fullWidth = "_2k-2";
export var lg = "_2k-7";
export var md = "_2k-6";
export var redoButtonTabGroup = "_2k-0";
export var sm = "_2k-5";
export var tabButton = "_2k-3";
export var tabButtonsContainer = "_2k-1";
export var xs = "_2k-4";